/**
 * Sesión del Vault — el token de desbloqueo vive SOLO en memoria.
 *
 * Nunca localStorage/sessionStorage: cerrar la pestaña = bloquear. El backend
 * lo emite en `vault.unlock` / `vault.setupPassphrase` (15 min) y lo exige en
 * el header `x-vault-unlock` para revelar secretos. `trpc.ts` lo agrega solo a
 * las llamadas `vault*`.
 *
 * Store mínimo con suscripción para `useSyncExternalStore` (hooks/useVault.ts).
 */

import { createListeners } from './listeners';

let token: string | null = null;
let expiresAt = 0;
const session = createListeners<void>();
const notify = () => session.notify();

export function setVaultUnlockToken(nextToken: string, expiresInMinutes: number): void {
  token = nextToken;
  expiresAt = Date.now() + expiresInMinutes * 60_000;
  notify();
}

export function clearVaultUnlockToken(): void {
  if (token === null) return;
  token = null;
  expiresAt = 0;
  notify();
}

/** null si no hay token o venció (y en ese caso lo limpia). */
export function getVaultUnlockToken(): string | null {
  if (token && Date.now() < expiresAt) return token;
  if (token) clearVaultUnlockToken();
  return null;
}

/** Epoch ms del vencimiento, o null. */
export function getVaultUnlockExpiry(): number | null {
  return getVaultUnlockToken() ? expiresAt : null;
}

export const subscribeVaultSession = session.subscribe;

// ─── MFA_REQUIRED en medio de una sesión ───────────────────────────────────────
// Cada vault.* re-verifica el 2SV de Google; si deja de estar activo (o la
// Directory API tuvo un blip) el backend contesta MFA_REQUIRED. withUnlockRetry
// avisa acá y VaultProtectedRoute vuelve a consultar el acceso: la persona ve la
// pantalla de 2SV en vez de un error crudo (auditoría 28/09).
const mfaRequired = createListeners<void>();
export const subscribeMfaRequired = mfaRequired.subscribe;
export function notifyMfaRequired(): void {
  clearVaultUnlockToken();
  mfaRequired.notify();
}
